import type { Dayjs, OptionType } from 'dayjs';
import dayjs, { isDayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import { language } from './browser';

dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

// INIT DAYJS
export function updateDayjsLocale() {
  const lang = language ?? 'en';
  if (lang !== 'en') {
    import(/* webpackPrefetch: true */ `dayjs/locale/${lang}.js`).then(() => {
      dayjs.locale(lang);
    });
  }
}

/**
 * return the date in string format
 * @param date - the date object
 * @param format - the output format
 * @param parseFormat - the parse format
 */
export function dateToString(date: Date | Dayjs | string, format = 'YYYY-MM-DD', parseFormat?: string) {
  if (!date) return;

  if (!isDayjs(date)) date = dayjs(date, parseFormat);

  return date.format(format);
}

export function parseDate(dateString: string, format?: OptionType) {
  if (dateString?.includes && dateString.includes('Date'))
    return dayjs(parseInt(dateString.replace(/"?\\?\/Date\((\d+)\)\\?\/"?/g, '$1')));

  return dayjs(dateString, format);
}

/**
 * return a date from string with a fallback to Now
 * @param dateString - the date string
 */
export function stringToDate(dateString: string) {
  const date = dayjs(dateString).isValid() ? dayjs(dateString) : dayjs();
  return date.toDate();
}
